export const planTypes = {
    GET_PLANS: "GET_PLANS",
};